<div class="p-4 overflow-auto h-[85vh]">
  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">WhatsApp Configurations</h2>
    <p-button icon="pi pi-plus" label="Add Configuration" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table
    [value]="whatsappConfigs"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onLazyLoad)="loadConfigs($event)"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>App Name</th>
        <th>Source</th>
        <th>Email</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-config>
      <tr>
        <td>{{ config.app_name }}</td>
        <td>{{ config.source }}</td>
        <td>{{ config.email }}</td>
        <td>{{ config.status }}</td>
        <td>
          <div (click)="setConfigData(config)">
            <p-menu [tabindex]="undefined" #menu [model]="configActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="5" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="no-data">
          <p>No WhatsApp configurations found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{ width: '50rem' }" [closable]="false">
    <app-create-whatsapp-config
      [clientId]="clientId"
      (reload)="reload()"
      (close)="closeAddModal()"
    ></app-create-whatsapp-config>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showEditConfig">
  <p-dialog [(visible)]="showEditConfig" [modal]="true" [style]="{ width: '50rem' }" [closable]="false">
    <app-create-whatsapp-config
      [clientId]="clientId"
      [type]="'Update'"
      [whatsappConfigDataToEdit]="configDataToEdit"
      (reload)="reload()"
      (close)="showEditConfig = false"
    ></app-create-whatsapp-config>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteConfig">
  <p-dialog [(visible)]="showDeleteConfig" [modal]="true" [style]="{ width: '40rem' }" [closable]="false">
    <app-delete-whatsapp-config
      [clientId]="clientId"
      [whatsappConfigDataToEdit]="configDataToEdit"
      (reload)="reload()"
      (close)="showDeleteConfig = false"
    ></app-delete-whatsapp-config>
  </p-dialog>
</ng-container>
